module.exports = __webpack_public_path__ + "static/img/member_icon_2.0b95d7e6.png";